// extracted by mini-css-extract-plugin
export default {"Spacer":"spacer_Spacer__50y9T"};